import {Component, Input, OnInit} from '@angular/core';
import { forEach } from 'lodash';

@Component({
    selector: 'app-insurer-rating',
    templateUrl: './insurer-rating.component.html',
    styleUrls: ['./insurer-rating.component.scss'],
    standalone: false
})
export class InsurerRatingComponent implements OnInit {
  @Input() ratings: any;
  @Input() position!: string;
  constructor() { }

  ngOnInit(): void {
    try{
      this.ratings = JSON.parse(this.ratings);
    }
    catch{}
    if (!Array.isArray(this.ratings)) { this.ratings = []; return; }
    let array =[];
    let types = Array.from(new Set(this.ratings.map((item: any) => item.rating_type)))
    types.forEach( (t) => {
      array.push(this.ratings.find(r => r?.rating_type === t));
    });
    this.ratings = array;
  }
  getStars(): any {


    let ratingsArray: any[] = [];
    let star: string[] = [];
    let currentRatings = this.ratings;

    // 1. Check if currentRatings is a string and attempt to parse it as JSON
    if (typeof currentRatings === 'string') {
      try {
        // Attempt to parse the string into an array/object
        ratingsArray = JSON.parse(currentRatings);
      } catch (e) {
        // If parsing fails, it's not valid JSON. Log the error and proceed with an empty array.
        //console.error("Error: 'this.ratings' is a string but not valid JSON.", e);
        return [];
      }
    } else if (Array.isArray(currentRatings)) {
      // If it's already an array, use it directly
      ratingsArray = currentRatings;
    } else {
      // If it's undefined, null, or any other type we can't use
      return [];
    }
    try {
      star = this.ratings[0].star_css.split('|');
    }
    catch (e) {
      //console.log(e);
      star = [];
    }
    return star;
  }

}
